import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import quagga from 'quagga';
import _ from 'lodash';

class BarcodeScanner extends PureComponent {
  static propTypes = {
    onDetect: PropTypes.func,
  };

  static defaultProps = {
    onDetect: _.identity,
  };

  componentDidMount() {
    quagga.init(
      {
        locate: true,
        inputStream: {
          name: 'Live',
          type: 'LiveStream',
          constraints: {
            width: 640,
            height: 480,
            aspectRatio: { min: 1, max: 2 },
            facingMode: 'environment',
          },
        },
        decoder: {
          readers: ['code_128_reader', 'code_39_reader', 'ean_reader'],
        },
        numOfWorkers: window.navigator.hardwareConcurrency || 2,
      },
      err => {
        if (err) {
          console.error(err);
          return;
        }
        quagga.start();
      }
    );
    quagga.onDetected(this.onDetected);
  }

  componentWillUnmount() {
    quagga.stop();
    quagga.offDetected(this.onDetected);
  }

  onDetected = data => {
    const code = _.get(data, ['codeResult', 'code']);
    quagga.stop();
    this.props.onDetect(code);
  };

  render() {
    return <div id="interactive" className="viewport" />;
  }
}

export default BarcodeScanner;



// WEBPACK FOOTER //
// ../pos-master/packages/pos-components/src/BarcodeScanner/BarcodeScanner.jsx